import { render, staticRenderFns } from "./ClientAddWebsite.vue?vue&type=template&id=7febaf1f&"
import script from "./ClientAddWebsite.vue?vue&type=script&lang=ts&"
export * from "./ClientAddWebsite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7febaf1f')) {
      api.createRecord('7febaf1f', component.options)
    } else {
      api.reload('7febaf1f', component.options)
    }
    module.hot.accept("./ClientAddWebsite.vue?vue&type=template&id=7febaf1f&", function () {
      api.rerender('7febaf1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/ClientAddWebsite.vue"
export default component.exports